var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 356.293,
    height: 676.323,
    viewBox: "0 0 356.293 676.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M172.655,661.721H96.5l-8.4-8.4V90.9l8.4-8.4h85.159l8.4,8.4V621.774L353.766,357.2l9.008-8.4h71.949l9.008,8.4.662,393.217-9.008,8.4H350.83l-8.4-8.4-.662-356.868L181.059,653.317Z",
    transform: "translate(-88.1 -82.5)",
    fill: "#071233",
    opacity: 0.34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoH);
export default __webpack_public_path__ + "static/media/logo-h.251eefcafa497f108afd2497cc4645be.svg";
export { ForwardRef as ReactComponent };